const paymentTextContent = {
  headerText: "Let's get started...",
  initialTextSingle: "You're making a one-off donation of",
  initialTextMonthly: "You're making a repeating monthly donation of",
  initialTextDirectPayment: "You're making a payment of",
  initialTextMonthlyAARN: "You're subscribing for",
  initialTextPayin: "You're paying in",
  supplementaryTextMonthlyAARNOptedIn: 'a month, and will receive fun stuff in the post every 3 months, and 1 cuddly plushie!',
  supplementaryTextMonthlyAARNOptedOut: 'and have opted out of postal rewards. Made a mistake? You can still go back and opt in.',
  giftAidText1: 'Boost your donation by',
  giftAidText2: 'at no extra cost with Gift Aid. All it takes is one click to make your donation go 25% further.',
  checkboxLabelText: 'Yes, I would like Comic Relief to claim Gift Aid on my donation, any donations I make in the future and any I have made in the past 4 years.*',

  aarnPostalRewardsBoldText: 'Yes, please send me fun stuff in the post every 3 months, and 1 cuddly plushie!',
  aarnPostalRewardsSmallText: '(uncheck to opt out of receiving postal rewards)',

  legalText1: '* By ticking, I state I am a UK taxpayer making a personal donation and understand that if I pay less Income Tax and/or Capital Gains Tax than the amount of Gift Aid claimed on all my donations, it is my responsibility to pay any difference. Please note...',

  legalText2: '* By ticking, I state I am a UK taxpayer making a personal donation and understand that if I pay less Income Tax and/or Capital Gains Tax than the amount of Gift Aid claimed on all my donations, it is my responsibility to pay any difference. Please note that the money that Comic Relief claims back from HMRC as part of the Gift Aid scheme will be treated as unrestricted funds and used to support our general work, even if the original donation was made towards a specific appeal.',

  legalLinkText: 'Find out more'
};

export default paymentTextContent;
